import { FC, PropsWithChildren } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Typography } from '@mui/material';

import useAuthentication from '@/components/Authentication/useAuthentication';
import Link from '@/components/Link';
import FilterSection from '@/components/Search/components/Filters/common/FilterSection/FilterSection';
import handleSendEventGTM from '@/utils/googleTagManagerHelper';

import messages from './messages';

import useStyles from './styles';

const FrequentQuestions: FC<PropsWithChildren<unknown>> = () => {
  const { classes } = useStyles();
  const { formatMessage } = useIntl();

  const { authentication } = useAuthentication();

  const logClickOnFAQ = (question: string) => {
    handleSendEventGTM('clic_question', {
      user_id: authentication?.authData?.id,
      faq: question,
    });
  };
  return (
    <FilterSection title={formatMessage(messages.title)}>
      <Link
        key="link_faq1"
        href="https://les-sherpas.zendesk.com/hc/fr/articles/8193692318098-Qu-est-ce-que-le-Suivi-R%C3%A9gulier-"
        target="_blank"
        onClick={() =>
          logClickOnFAQ(formatMessage(messages.frequentQuestions1))
        }
      >
        <Typography
          className={classes.questionItem}
          variant="bodyMd"
          component="p"
        >
          <FormattedMessage {...messages.frequentQuestions1} />
        </Typography>
      </Link>

      <Link
        key="link_faq2"
        href="https://les-sherpas.zendesk.com/hc/fr/articles/360008473799-Qu-est-ce-que-le-premier-cours-offert-"
        target="_blank"
        onClick={() =>
          logClickOnFAQ(formatMessage(messages.frequentQuestions2))
        }
      >
        <Typography
          className={classes.questionItem}
          variant="bodyMd"
          component="p"
        >
          <FormattedMessage {...messages.frequentQuestions2} />
        </Typography>
      </Link>

      <Link
        key="link_faq3"
        href="https://les-sherpas.zendesk.com/hc/fr/articles/360008427634-Quels-sont-les-tarifs-de-vos-professeurs-"
        target="_blank"
        onClick={() =>
          logClickOnFAQ(formatMessage(messages.frequentQuestions3))
        }
      >
        <Typography
          className={classes.questionItem}
          variant="bodyMd"
          component="p"
        >
          <FormattedMessage {...messages.frequentQuestions3} />
        </Typography>
      </Link>
    </FilterSection>
  );
};

export default FrequentQuestions;
